export default "__VITE_ASSET__C74yIuF0__"